export const STRINGS = {
  APP_NAME: "Resumate",
  NAVBAR: {
    HOME: "Home",
    MY_CV: "My CV",
    LOGOUT: "Logout",
    SIGN_IN: "Sign In",
    ACCOUNT_MENU: "Account menu",
  },
  HOME: {
    BADGE: "✦ Your CV Builder",
    HERO_TITLE_1: "Build Your ",
    HERO_TITLE_GRADIENT: "Dream CV",
    HERO_TITLE_2: " That Gets You Hired",
    HERO_SUBTITLE: "Create a professional, ATS-friendly resume in minutes. Stand out from the crowd and land the job you deserve.",
    GET_STARTED: "Get Started Free →",
    SIGN_IN: "Sign In",
    GO_TO_CV: "Update My CV →",
    FEATURES: [
      { icon: "⚡", title: "Quick & Easy", desc: "Build your complete CV in under 10 minutes with our guided workflow." },
      { icon: "📄", title: "PDF Export", desc: "Download your CV as a polished, print-ready PDF instantly." },
      { icon: "🎯", title: "ATS Optimized", desc: "Clean formatting that passes applicant tracking systems." }
    ]
  },
  LABELS: {
    FULL_NAME: "Full Name",
    EMAIL: "Email Address",
    PHNO: "Phone Number",
    ADDRESS: "Address",
    LINKEDIN: "LinkedIn Profile",
    GITHUB: "GitHub Profile",
    DESIGNATION: "Designation",
    COMPANY_NAME: "Company Name",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    LEAVE_EMPTY: "Leave empty if still working",
    CURRENT_JOB: "I currently work here",
    BULLET_POINTS: "BULLET POINTS",
    CLICK_TO_ADD: "Click + to add bullet points.",
    QUALIFICATION: "Qualification",
    SCHOOL: "School / University",
    YEAR_PERIOD: "Year / Period",
    MARKS: "Marks",
    PROJECT_NAME: "Project Name",
    PROJECT_YEAR: "Year",
    PROJECT_LINK: "Project Link (URL)",
    ACHIEVEMENT_TITLE: "Achievement Title",
    ACHIEVEMENT_SUBTITLE: "Subtitle / Description"
  },
  UI: {
    NEXT: "Next →",
    SAVE_CV: "Save & View CV ✓",
    SAVE_DRAFT: "Save as Draft",
    ADD_WORK: "+ Add Work Experience",
    ADD_EDU: "+ Add Education",
    ADD_PROJ: "+ Add Project",
    ADD_ACHIEVE: "+ Add Achievement",
    EMPTY_WORK: { icon: "💼", title: "No work experience added yet.", hint: "Click the button below to add your professional history." },
    EMPTY_EDU: { icon: "🎓", title: "No education entries added yet.", hint: "Click the button below to add your qualifications." },
    EMPTY_PROJ: { icon: "🚀", title: "No projects added yet.", hint: "Click the button below to showcase your work." },
    EMPTY_ACHIEVE: { icon: "🏆", title: "No achievements added yet.", hint: "Click the button below to add your awards & milestones." },
    EDIT_CV: "Edit CV",
    DOWNLOAD_PDF: "Download PDF"
  },
  CV_SECTIONS: {
    CONTACT: "Contact Info",
    SKILLS: "Skills & Expertise",
    EXPERIENCE: "Professional Experience",
    PROJECTS: "Projects",
    EDUCATION: "Education",
    ACHIEVEMENTS: "Achievements",
    LANGUAGES: "Languages",
    INTERESTS: "Interests"
  }
};
